import '.s{position:fixed;}.ssr-plugin'
import '.e0{top:0px;}.ssr-plugin'
import '.ba{left:0px;}.ssr-plugin'
import '.bb{right:0px;}.ssr-plugin'
import '.fh{bottom:0px;}.ssr-plugin'
import '.gu{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gv{z-index:998;}.ssr-plugin'
import '.gw{transition:opacity 0.3s ease;}.ssr-plugin'
import '.v{height:100vh;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.ah{background-color:var(--palette-white);}.ssr-plugin'
import '.gx{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.gy{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.a2{justify-content:space-between;}.ssr-plugin'
import '.bw{padding:1.5rem;}.ssr-plugin'
import '.gz{border-bottom:var(--border-default);}.ssr-plugin'
import '.be{flex-shrink:0;}.ssr-plugin'
import '.bl{flex:1;}.ssr-plugin'
import '.ay{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="s e0 ba bb fh gu gv gw"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="s e0 v a1 ah gx gy a e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a f a2 bw gz be"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bl ay bw"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
